import { CASE_DATA_KEY, BUSINESS_UUID } from '../../utils/constants';
import { getUsername } from './selectors';

export const updateCasePayload = (state) => {
  const caseData = state.cases.get(CASE_DATA_KEY).toJS();
  return JSON.stringify(getUpdateCasePayload(state, caseData));
};

/**
 * Update customer payload
 * @param {object} state
 * @param {object} customer
 */
export const getUpdateCasePayload = (state, caseData) => {
  const commonData = {};
  commonData.applicant = {};
  caseData.audit_info.documents = [];
  caseData.audit_info.eligibility_questions = [];
  const auditInfo = caseData.audit_info;
  caseData.customer_id.business =
    state.dataCapture.get(BUSINESS_UUID) || state.config.get(BUSINESS_UUID) || '';
  const custId = caseData.customer_id;
  commonData.source_id = caseData.source_id;
  commonData.case_subtype = caseData.case_subtype.toLowerCase();
  commonData.product = Object.assign({}, caseData.product);
  commonData.customer_id = Object.assign({}, custId);
  commonData.audit_info = Object.assign({}, auditInfo);
  commonData.applicant.user_details = getApplicant(state);
  commonData.sales_leads = [];
  return commonData;
};

const getApplicant = (state) => {
  const userDetails = {};
  userDetails.username = getUsername(state) || '';
  return userDetails;
};
